import { render, staticRenderFns } from "./WorkbenchPreview.vue?vue&type=template&id=367cf237&scoped=true&"
import script from "./WorkbenchPreview.vue?vue&type=script&lang=js&"
export * from "./WorkbenchPreview.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchPreview.vue?vue&type=style&index=0&id=367cf237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367cf237",
  null
  
)

export default component.exports